import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { map, Observable } from "rxjs";
import { AuthService } from "../services/auth.service";

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(
        private readonly auth: AuthService,
        private readonly router: Router
        ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): 
        boolean | 
        UrlTree | 
        Observable<boolean | UrlTree> 
        | Promise<boolean 
        | UrlTree> {
        return this.auth.isLoggedIn$
            .pipe(
                map(isLoggedIn => {
                    if (!isLoggedIn) return this.router.createUrlTree(['auth','login']);
                    return true;
                })
            )
    }

}